import React, { PureComponent, Fragment, createContext } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import FlipMove from "react-flip-move";
import { SketchPicker } from "react-color";
import { stack as MobileMenu } from "react-burger-menu";
import CSSModules from "react-css-modules";
import Modal from "react-modal";
import * as Scroll from "react-scroll";

import classNames from "classnames/bind";
import axios from "axios";
import isEqual from "lodash/isEqual";
import css from "styled-jsx/css";

import { updateSettings, deleteTab, addTab, changeTab } from "./store/actions";

import getIcon from "form-components/lib/__utils/getIcon";
import hexToRgb from "form-components/lib/__utils/helpers/hexToRgb";

import TabsContainer from "form-components/lib/TabsContainer";

import CardInput from "form-components/lib/CardInput";
import CvcInput from "form-components/lib/CvcInput";
import DateInput from "form-components/lib/DateInput";
import Button from "form-components/lib/Button";
import Footer from "form-components/lib/Footer";
import Spacer from "form-components/lib/Spacer";

import PhoneInput from "form-components/lib/PhoneInput";
import DestinationInput from "form-components/lib/DestinationInput";

import SelectInput from "form-components/lib/SelectInput";

import autoContrasts from "form-components/lib/__utils/autoContrasts";
import rgbToHsv from "form-components/lib/__utils/helpers/rgbToHsv";
import calculateOptions from "form-components/lib/__utils/calculateOptions";

import styles from "./App.scss";

Modal.setAppElement("#root");

const cx = classNames.bind(styles);

const Element = Scroll.Element;
const Scroller = Scroll.scroller;

const propTypes = {
  settings: PropTypes.shape({
    layout: PropTypes.string,
    theme: PropTypes.string,
    main: PropTypes.string,
    background: PropTypes.string,
    text: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.string)
  }),
  dispatch: PropTypes.func
};

const defaultProps = {
  settings: null,
  dispatch: null
};

const ThemeProvider = createContext();

const presets = [
  ["#f75f52", "#000000", "#ffffff", "light"],
  ["#4aeaf0", "#ffffff", "#7b71ef", "dark"],
  ["#5ec96b", "#ffffff", "#2e3b50", "dark"],
  ["#327ef9", "#000000", "#ffffff", "light"],
  ["#b05ff4", "#000000", "#ffffff", "light"],
  ["#f53963", "#ffffff", "#3a3057", "dark"]
];

const DEFAULT_THEME = {
  theme: "light",
  main: "#F75F52",
  text: "#000000",
  background: "#ffffff"
};

const MARGIN_FOR_BUTTON = {
  form: {
    default: 36,
    material: 45,
    ios: 0
  }
};

const container = css`
  .widget-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const padding = {
  default: "0",
  material: "0 16px",
  ios: "0"
};


class Form extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pickerType: "main",
      modalIsOpen: false,
      email: "",
      activeIndex: 0,
      active: false,
      loading: false,
      isLoaded: false,
      isError: false,
      data: "",
      main: "",
      background: "",
      text: ""
    };
    this.handleControls = this.handleControls.bind(this);
    this.handleSettings = this.handleSettings.bind(this);
    this.applyDisabled = this.applyDisabled.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.setCurrentTab = this.setCurrentTab.bind(this);
  }

  componentDidMount() {
    const { settings } = this.props;

    this.setState({
      main: settings.main.substring(1),
      background: settings.background.substring(1),
      text: settings.text.substring(1)
    });
  }

  handleValueChange(e) {
    const { dispatch, settings } = this.props;
    const { target } = e;

    this.setState({ [target.name]: target.value });

    if (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(`#${target.value}`)) {
      dispatch(updateSettings([[target.name, `#${target.value}`]]));

      if (target.name === "background") {
        const theme = autoContrasts(
          ...rgbToHsv(...hexToRgb(target.value), "deg")
        );

        let text;

        if (
          theme === "dark" &&
          (settings.text === "#000" || settings.text === "#000000")
        ) {
          text = ["text", "#ffffff"];
          this.setState({ text: "ffffff" });
        } else if (
          theme === "light" &&
          (settings.text === "#fff" || settings.text === "#ffffff")
        ) {
          text = ["text", "#000000"];
          this.setState({ text: "000000" });
        } else {
          text = false;
        }

        dispatch(
          updateSettings(
            [text, ["theme", theme]].filter((item) => item !== false)
          )
        );
      }
    }
  }

  scrollTo(scrollElement) {
    if (window && window.innerWidth <= 960) {
      setTimeout(() => {
        Scroller.scrollTo(scrollElement, {
          duration: 800,
          delay: 0,
          smooth: "easeInOutQuart",
          isDynamic: true
        });
      }, 0);
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const { settings } = this.props;

    const dataSettings = {
      layout: settings.layout,
      theme: settings.theme,
      main: settings.main,
      background: settings.background,
      text: settings.text,
      tabs: settings.tabs
    };

    const data = JSON.stringify({
      email: this.state.email,
      settings: dataSettings
    });

    const bindingDelay = (ms) => new Promise((r) => setTimeout(r, ms));

    this.setState({ active: true });

    bindingDelay(200).then(() => {
      this.setState({ loading: true });
      axios
        .post("https://arsenalpay.ru/arsenalpay-api/customization.php", data)
        .then((response) => {
          const responseData = response.data;
          const { statusText, text } = responseData;

          if (statusText === "ERROR") {
            this.setState({ isError: true });
          }
          this.setState({
            loading: false,
            isLoaded: true,
            data: text
          });
        })
        .catch(() => {
          this.setState({
            isError: true,
            loading: false,
            isLoaded: true
          });
        });
    });
  }

  handleControls(index) {
    this.setState(
      (state) => (state.activeIndex === index ? null : { activeIndex: index }),
    );
  }

  applyDisabled(tabName) {
    const { settings } = this.props;

    return settings.tabs.length === 1 && settings.tabs.includes(tabName);
  }

  handleTab(tabName) {
    const { settings, dispatch } = this.props;

    dispatch(
      settings.tabs.includes(tabName) ? deleteTab(tabName) : addTab(tabName)
    );
  }

  handleSettings(color, storeField, presetField) {
    const { dispatch, settings } = this.props;
    const { text } = settings;

    if (storeField === "background") {
      const { h, s, v } = color.hsv;

      let dispatchSettings;
      const theme = autoContrasts(h, s, v);

      switch (theme) {
        case "light":
          dispatchSettings = [
            ["theme", "light"],
            ["userTheme", "light"],
            ["text", text !== "#ffffff" ? text : "#000000"],
            ["textPreset", text !== "#ffffff" ? text : "#000000"]
          ];
          break;
        case "dark":
          dispatchSettings = [
            ["theme", "dark"],
            ["userTheme", "dark"],
            ["text", text !== "#000000" ? text : "#ffffff"],
            ["textPreset", text !== "#000000" ? text : "#ffffff"]
          ];
          break;
        default:
          break;
      }

      dispatch(updateSettings(dispatchSettings));
    }

    dispatch(
      updateSettings([
        [storeField, `${color.hex}`],
        [presetField, `${color.hex}`]
      ])
    );

    this.setState({ [storeField]: `${color.hex.substring(1)}` });

    if (
      isEqual(presets[settings.presetIndex], [
        settings.main,
        settings.text,
        settings.background,
        settings.theme
      ])
    ) {
      dispatch(
        updateSettings(
          [
            ["mainPreset", storeField === "main" ? color.hex : settings.main],
            ["textPreset", storeField === "text" ? color.hex : settings.text],
            [
              "backgroundPreset",
              storeField === "background" ? color.hex : settings.background
            ],
            ["userTheme", settings.theme],
            !settings.isPresetChanged ? ["isPresetChanged", true] : false
          ].filter((item) => item !== false)
        )
      );
    }
  }

  setCurrentTab(index) {
    const {dispatch, settings: {tabs}} = this.props;

    dispatch(changeTab({
      id: index,
      name: tabs[index]
    }));
  }

  render() {
    const { dispatch, settings, settings: { layout, theme, background, tabIndex } } = this.props;
    const { pickerType, activeIndex } = this.state;

    const defaultSettings = {
      layout,
      theme,
      background
    };

    const isDefaultTheme = settings.main === DEFAULT_THEME.main
      && settings.text === DEFAULT_THEME.text
      && background === DEFAULT_THEME.background
      && theme === DEFAULT_THEME.theme;

    const currentTheme = isDefaultTheme
      ? defaultSettings
      : {
        ...calculateOptions(settings, layout, theme),
        ...defaultSettings
      };

    const FORM = {
      card: (
        <ThemeProvider.Provider value={currentTheme}>
          <ThemeProvider.Consumer>
            {(options) => (
              <div
                className="widget-container"
                style={{ padding: padding[options.layout] }}
              >
                <CardInput
                  id="kgB7ur"
                  placeholder="0000 0000 0000 0000"
                  defaultValue="4242424242424242"
                  {...options}
                />
                <DateInput
                  id="u0eFZB"
                  placeholder="00 / 00"
                  width="medium"
                  defaultValue="1220"
                  {...options}
                />
                <CvcInput
                  id="GH7Wg6"
                  placeholder="CVC"
                  helpButton
                  width="medium"
                  defaultValue="123"
                  {...options}
                />
                <Spacer minHeight={MARGIN_FOR_BUTTON.form[layout]}/>
                <Button {...options} >Оплатить 1 500</Button>
                <Footer {...options} />
                <style jsx>{container}</style>
              </div>
            )}
          </ThemeProvider.Consumer>
        </ThemeProvider.Provider>
      ),
      phone: (
        <ThemeProvider.Provider value={currentTheme}>
          <ThemeProvider.Consumer>
            {(options) => (
              <div
                className="widget-container"
                style={{ padding: padding[options.layout] }}
              >
                <PhoneInput
                  id="pfPb6O"
                  placeholder="+7 (900) 000-00-00"
                  defaultValue="9000000000"
                  helpButton
                  {...options}
                />
                <DestinationInput
                  id="ymgC2D"
                  placeholder="000000"
                  defaultValue="123456"
                  helpButton
                  {...options}
                />
                <Spacer minHeight={MARGIN_FOR_BUTTON.form[layout]}/>
                <Button {...options}>Оплатить 1 500</Button>
                <Footer {...options} />
                <style jsx>{container}</style>
              </div>
            )}
          </ThemeProvider.Consumer>
        </ThemeProvider.Provider>
      ),
      wallet: (
        <ThemeProvider.Provider value={currentTheme}>
          <ThemeProvider.Consumer>
            {(options) => (
              <div
                className="widget-container"
                style={{ padding: padding[options.layout] }}
              >
                <SelectInput
                  selectOptions={[
                    { value: "qiwi", label: "QIWI" },
                    { value: "webmoney", label: "WebMoney" }
                  ]}
                  id="G5RRvK"
                  {...options}
                />
                <PhoneInput
                  id="pfPb61"
                  placeholder="+7 (900) 000-00-00"
                  defaultValue="9000000000"
                  helpButton
                  {...options}
                />
                <Spacer minHeight={MARGIN_FOR_BUTTON.form[layout]}/>
                <Button {...options}>Оплатить 1 500</Button>
                <Footer {...options}/>
                <style jsx>{container}</style>
              </div>
            )}
          </ThemeProvider.Consumer>
        </ThemeProvider.Provider>
      )
    };

    let pickerColor = "";
    let storeField = "";
    let presetField = "";

    switch (pickerType) {
      case "main":
        pickerColor = settings.main;
        storeField = "main";
        presetField = "mainPreset";
        break;
      case "background":
        pickerColor = settings.background;
        storeField = "background";
        presetField = "backgroundPreset";
        break;
      default:
        pickerColor = settings.text;
        storeField = "text";
        presetField = "textPreset";
        break;
    }

    return (
      <div id="reveal-container">
        <div styleName="extra-small">
          Ваше устройство несовместимо с данным сайтом
        </div>
        <div styleName="navigation-container">
          <header>
            <nav styleName="menu">
              <ul>
                <div styleName="logotype">
                  <li>
                    <a href="https://arsenalpay.ru">ArsenalPay</a>
                  </li>
                </div>
                <div styleName="links">
                  <li>
                    <a
                      href="https://arsenalpay.ru/documentation.html#54-fz-integraciya-s-onlajn-kassoj">
                      Онлайн касса
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://arsenalpay.ru/documentation.html#bez-dogovora">
                      Без договора
                    </a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/tariffs.html">Тарифы</a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/demo.html">Демо</a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/pay/">Оплата</a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/developers.html">
                      Разработчикам
                    </a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/partnership.html">Агентам</a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/support.html">Поддержка</a>
                  </li>
                  <li>
                    <a href="https://arsenalpay.ru/#loginModal">Войти</a>
                  </li>
                </div>
                <div styleName="mobile">
                  <MobileMenu
                    right
                    overlayClassName={cx("menu-overlay")}
                    menuClassName={cx("mobile-menu")}
                    itemListClassName={cx("mobile-overflow")}
                    crossButtonClassName={cx("mobile-close-button")}
                    burgerButtonClassName={cx("mobile-burder-button")}
                    bodyClassName={cx("hide-overflow")}>
                    <div styleName="mobile-links">
                      <li>
                        <a href="https://arsenalpay.ru">Главная</a>
                      </li>
                      <li>
                        <a
                          href="https://arsenalpay.ru/documentation.html#54-fz-integraciya-s-onlajn-kassoj">
                          Онлайн касса
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://arsenalpay.ru/documentation.html#bez-dogovora">
                          Без договора
                        </a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/tariffs.html">Тарифы</a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/demo.html">Демо</a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/pay/">Оплата</a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/developers.html">
                          Разработчикам
                        </a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/partnership.html">
                          Агентам
                        </a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/support.html">
                          Поддержка
                        </a>
                      </li>
                      <li>
                        <a href="https://arsenalpay.ru/#loginModal">Войти</a>
                      </li>
                    </div>
                  </MobileMenu>
                </div>
              </ul>
            </nav>
          </header>
        </div>
        <div styleName="container">
          <main>
            <section styleName="description">
              <h1>Ваш дизайн виджета оплаты</h1>
              <p>Фирменные цвета</p>
            </section>
            <Element styleName="controls" name="scroll-controls">
              <aside styleName="form">
                <Element styleName="theme-controls" name="scroll-theme">
                  <input
                    type="radio"
                    id="material"
                    checked={settings.layout === "material"}
                    onChange={() => {
                      dispatch(updateSettings([["layout", "material"]]));
                      this.scrollTo("scroll-theme");
                    }}
                  />
                  <label htmlFor="material">Android</label>
                  <input
                    type="radio"
                    id="ios"
                    checked={settings.layout === "ios"}
                    onChange={() => {
                      dispatch(updateSettings([["layout", "ios"]]));
                      this.scrollTo("scroll-theme");
                    }}
                  />
                  <label htmlFor="ios">iPhone</label>
                  <input
                    type="radio"
                    id="default"
                    checked={settings.layout === "default"}
                    onChange={() => {
                      dispatch(updateSettings([["layout", "default"]]));
                      this.scrollTo("scroll-theme");
                    }}
                  />
                  <label htmlFor="default">На сайте</label>
                </Element>
                <div styleName="form-container" className={cx(settings.layout)}>
                  {settings.layout === "material" && (
                    <div
                      styleName="material-bar"
                      style={{ backgroundColor: settings.main }}
                    />
                  )}
                  {settings.layout === "ios" && (
                    <div
                      className={cx("ios-bar", settings.theme)}
                      style={
                        settings.theme === "dark"
                          ? { backgroundColor: settings.background }
                          : null
                      }>
                      <div styleName="icons" id="ios-icons">
                        <div styleName="arrow" className="arrow"/>
                        <div styleName="star" className="star"/>
                      </div>
                      <style jsx global>
                        {`
													div#ios-icons {
														.arrow {
															background-image: ${`url(${
                          getIcon(
                            settings.theme,
                            hexToRgb(settings.main),
                            "IOS_ARROW"
                          ).svg
                          })`};
														}
														.star {
															background-image: ${`url(${
                          getIcon(
                            settings.theme,
                            hexToRgb(settings.main),
                            "IOS_STAR"
                          ).svg
                          })`};
														}
													}
												`}
                      </style>
                    </div>
                  )}
                  <div
                    className={cx(`${settings.layout}-container`)}
                    style={{ backgroundColor: `${settings.background}` }}>
                    <Modal
                      isOpen={this.state.modalIsOpen}
                      onRequestClose={() =>
                        this.setState({ modalIsOpen: false })
                      }
                      styleName="modal"
                      closeTimeoutMS={200}
                      style={{
                        overlay: {
                          backgroundColor: `rgba(0, 0, 0, 0.1)`,
                          zIndex: "9999"
                        }
                      }}
                    >
											<span
                        styleName="close-button"
                        onClick={() => this.setState({ modalIsOpen: false })}
                        onKeyDown={() => {
                        }}
                        role="button"
                        tabIndex="0"
                      />
                      <div styleName="modal-content">
                        <div styleName="modal-width">
                          {this.state.isLoaded ? (
                            <Fragment>
                              {!this.state.isError ? (
                                <Fragment>
                                  <div
                                    className={cx(
                                      "sa-icon",
                                      "sa-success",
                                      "animate"
                                    )}>
																		<span
                                      className={cx(
                                        "sa-line",
                                        "sa-tip",
                                        "animateSuccessTip"
                                      )}
                                    />
                                    <span
                                      className={cx(
                                        "sa-line",
                                        "sa-long",
                                        "animateSuccessLong"
                                      )}
                                    />
                                    <div styleName="sa-placeholder"/>
                                    <div styleName="sa-fix"/>
                                  </div>
                                  <h2>Регистрация успешна</h2>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <div styleName="swal2-icon">
                                    <span styleName="swal2-x-mark"/>
                                  </div>
                                  <h2>Произошла ошибка</h2>
                                </Fragment>
                              )}
                              <p>
                                {!this.state.data
                                  ? "Произошла неизвестная ошибка, попробуйте позже"
                                  : this.state.data}
                              </p>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <h2>Сохранение виджета</h2>
                              <p>
                                Настройки для виджета и все инструкции по
                                интеграции виджета на ваш сайт придут к вам на
                                email
                              </p>
                              <form onSubmit={this.handleSubmit}>
                                <div styleName="input-container">
                                  <label htmlFor="email">
                                    Введите ваш email
                                  </label>
                                  <input
                                    type="email"
                                    placeholder="example@mail.com"
                                    id="email"
                                    name="email"
                                    value={this.state.email}
                                    onChange={(e) =>
                                      this.setState({ email: e.target.value })
                                    }
                                    required
                                  />
                                </div>
                                <button
                                  className={cx(
                                    "submit-button",
                                    this.state.active && "active",
                                    this.state.loading && "loading"
                                  )}>
                                  Сохранить виджет
                                </button>
                              </form>
                            </Fragment>
                          )}
                        </div>
                      </div>
                    </Modal>
                    <style jsx global>
                      {`
												.ReactModal__Body--open {
													overflow-y: hidden;
												}

												.ReactModalPortal > * {
													opacity: 0;
												}

												.ReactModal__Overlay {
													transition: 0.2s opacity ease-in-out;

													&--after-open {
														opacity: 1;
													}

													&--before-close {
														opacity: 0;
													}
												}
											`}
                    </style>
                    <ThemeProvider.Provider value={currentTheme}>
                      <ThemeProvider.Consumer>
                        {(options) => (
                          <TabsContainer
                            tabsOptions={settings.tabs.map((tab) => ({
                              name: tab,
                              content: FORM[tab]
                            }))}
                            currentTab={tabIndex.id}
                            setCurrentTab={this.setCurrentTab}
                            forceRenderTabPanel
                            {...options}
                          />
                        )}
                      </ThemeProvider.Consumer>
                    </ThemeProvider.Provider>
                    {(settings.layout === "material" ||
                      settings.layout === "ios") && (
                      <div
                        styleName="save-container"
                        className={cx(settings.layout)}
                        onClick={() =>
                          this.setState({
                            modalIsOpen: true,
                            isLoaded: false,
                            active: false,
                            email: "",
                            isError: false
                          })
                        }
                        role="button"
                        onKeyDown={() => {
                        }}
                        tabIndex="0">
                        <span>Сохранить виджет</span>
                      </div>
                    )}
                  </div>
                  {settings.layout === "default" && (
                    <div
                      styleName="save-container"
                      className={cx(settings.layout)}
                      onClick={() =>
                        this.setState({
                          modalIsOpen: true,
                          isLoaded: false,
                          active: false,
                          email: "",
                          isError: false
                        })
                      }
                      role="button"
                      onKeyDown={() => {
                      }}
                      tabIndex="0">
                      <span>Сохранить виджет</span>
                    </div>
                  )}
                </div>
              </aside>
              <section styleName="pickers">
                <Element style={{ width: "100%" }} name="scroll-buttons">
                  <FlipMove styleName="color-controls">
                    {settings.isPresetChanged ? (
                      <div
                        className={cx(
                          "button",
                          "user-preset",
                          isEqual(
                            [settings.main, settings.text, settings.background],
                            [
                              settings.mainPreset,
                              settings.textPreset,
                              settings.backgroundPreset
                            ]
                          )
                            ? "active"
                            : null
                        )}
                        role="button"
                        onKeyDown={() => {
                        }}
                        tabIndex="0"
                        onClick={() => {
                          dispatch(
                            updateSettings([
                              ["main", settings.mainPreset],
                              ["text", settings.textPreset],
                              ["background", settings.backgroundPreset],
                              ["theme", settings.userTheme]
                            ])
                          );
                          this.scrollTo("scroll-buttons");
                          this.setState({
                            main: settings.mainPreset.substring(1),
                            text: settings.textPreset.substring(1),
                            background: settings.backgroundPreset.substring(1)
                          });
                        }}
                        style={
                          isEqual(
                            [settings.main, settings.text, settings.background],
                            [
                              settings.mainPreset,
                              settings.textPreset,
                              settings.backgroundPreset
                            ]
                          )
                            ? { borderColor: "rgba(0, 0, 0, 0.65)" }
                            : null
                        }>
                        <svg
                          width="40px"
                          height="38px"
                          viewBox="0 0 40 38"
                          styleName="dot">
                          <defs/>
                          <g
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd">
                            <path
                              d="M19.0235228,37.9777506 C20.9107881,35.0779132 22,31.6597961 22,28 C22,24.7423491 21.1370062,21.6761831 19.6163581,18.9965743 C19.74395,18.9988547 19.8718342,19 20,19 C27.4028236,19 33.8662619,15.179113 37.3243561,9.5 C39.0260571,12.294647 40,15.5392721 40,19 C40,29.4934102 31.045695,38 20,38 C19.6726107,38 19.3470588,37.9925269 19.0235228,37.9777506 Z"
                              fill={`${settings.textPreset}`}
                            />
                            <path
                              d="M2.67564391,9.5 C6.13373811,3.82088698 12.5971764,0 20,0 C27.4028236,0 33.8662619,3.82088698 37.3243561,9.5 C33.8662619,15.179113 27.4028236,19 20,19 C12.5971764,19 6.13373811,15.179113 2.67564391,9.5 Z"
                              fill={`${settings.mainPreset}`}
                            />
                            <path
                              d="M2.97647722,9.0222494 C13.5686315,9.50600815 22,17.8176096 22,28 C22,31.6597961 20.9107881,35.0779132 19.0235228,37.9777506 C8.43136851,37.4939918 0,29.1823904 0,19 C0,15.3402039 1.08921188,11.9220868 2.97647722,9.0222494 Z"
                              fill={`${settings.backgroundPreset}`}
                            />
                          </g>
                        </svg>
                      </div>
                    ) : null}
                    {presets.map((color, index) => (
                      <div
                        styleName="button"
                        style={
                          isEqual(
                            [settings.main, settings.text, settings.background],
                            [color[0], color[1], color[2]]
                          )
                            ? { borderColor: `${color[0]}` }
                            : null
                        }
                        className={cx(
                          isEqual(
                            [settings.main, settings.text, settings.background],
                            [color[0], color[1], color[2]]
                          )
                            ? "active"
                            : null
                        )}
                        key={color}
                        onClick={() => {
                          dispatch(
                            updateSettings([
                              ["main", `${color[0]}`],
                              ["text", `${color[1]}`],
                              ["background", `${color[2]}`],
                              ["theme", `${color[3]}`],
                              ["presetIndex", index]
                            ])
                          );
                          this.setState({
                            main: color[0].substring(1),
                            text: color[1].substring(1),
                            background: color[2].substring(1)
                          });
                          this.scrollTo("scroll-buttons");
                        }}
                        role="button"
                        onKeyDown={() => {
                        }}
                        tabIndex="0">
                        <div
                          styleName="dot"
                          style={{ backgroundColor: `${color[0]}` }}
                        />
                      </div>
                    ))}
                  </FlipMove>
                </Element>
                <Element
                  styleName="switcher"
                  className={cx(activeIndex !== 0 ? "active" : null)}
                  name="switcher-container">
                  <div
                    className={cx(activeIndex === 1 ? "active" : null)}
                    onClick={() => {
                      this.handleControls(1);
                      this.scrollTo("switcher-container");
                    }}
                    role="button"
                    onKeyDown={() => {
                    }}
                    tabIndex="0">
                    Настроить цвета
                  </div>
                  <div
                    className={cx(activeIndex === 2 ? "active" : null)}
                    onClick={() => {
                      this.handleControls(2);
                      this.scrollTo("switcher-container");
                    }}
                    role="button"
                    onKeyDown={() => {
                    }}
                    tabIndex="0">
                    Способы оплаты
                  </div>
                  <span
                    styleName="close-cross"
                    onClick={() => {
                      this.handleControls(0);
                      this.scrollTo("scroll-controls");
                    }}
                  />
                </Element>
                <div
                  styleName="control-pickers"
                  style={activeIndex === 1 ? { display: "block" } : null}>
                  <div styleName="color-pickers">
                    <div styleName="values">
                      {[
                        ["Цвет кнопки", "main"],
                        ["Цвет текста", "text"],
                        ["Цвет фона", "background"]
                      ].map((elem) => (
                        <div
                          styleName="value-button"
                          key={elem[1]}
                          className={cx(
                            pickerType === elem[1] ? "active" : null
                          )}>
                          <span styleName="label">{elem[0]}</span>
                          <span
                            styleName="value"
                            className={cx(
                              pickerType === elem[1] ? "active" : null
                            )}
                            onClick={() =>
                              this.setState({ pickerType: elem[1] })
                            }
                            role="button"
                            onKeyDown={() => {
                            }}
                            tabIndex="0">
														<span
                              styleName="color"
                              style={{
                                backgroundColor: `${settings[`${elem[1]}`]}`
                              }}
                            />
														<span styleName="hash">#</span>
														<input
                              type="text"
                              value={this.state[elem[1]]}
                              styleName="hash-value"
                              name={elem[1]}
                              onChange={this.handleValueChange}
                              maxLength="6"
                            />
													</span>
                        </div>
                      ))}
                    </div>
                    <div styleName="picker">
                      <SketchPicker
                        presetColors={[]}
                        disableAlpha
                        width="100%"
                        color={pickerColor}
                        onChangeComplete={(color) =>
                          this.handleSettings(color, storeField, presetField)
                        }
                      />
                      <style jsx global>
                        {`
													.sketch-picker {
														padding: 0 !important;
														border-radius: 0 !important;
														box-shadow: none !important;

														div.saturation-white {
															div:nth-child(2) {
																div {
																	width: 10px !important;
																	height: 10px !important;
																	box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5) !important;
																	border: solid 1px white;
																}
															}
														}

														.field {
															padding-bottom: 188px !important;
														}

														@media (min-width: 420px) and (max-width: 935px) {
															.field {
																padding-bottom: 155px !important;
															}
														}

														@media (min-width: 279px) and (max-width: 420px) {
															.field {
																padding-bottom: 125px !important;
															}
														}

														div:first-child {
															border-radius: 6px;
														}

														div.flexbox-fix:nth-child(3) {
															display: none !important;
														}
													}
												`}
                      </style>
                    </div>
                  </div>
                </div>
                <div
                  styleName="checkboxes"
                  style={activeIndex === 2 ? { display: "block" } : null}>
                  <span styleName="label">Способы оплаты</span>
                  <div styleName="checkbox-controls">
                    <input
                      type="checkbox"
                      id="cards"
                      checked={settings.tabs.includes("card")}
                      disabled={this.applyDisabled("card")}
                      onChange={() => this.handleTab("card")}
                    />
                    <label htmlFor="cards">
                      <span styleName="check"/>
                      Карты
                    </label>
                    <input
                      type="checkbox"
                      id="phone"
                      checked={settings.tabs.includes("phone")}
                      disabled={this.applyDisabled("phone")}
                      onChange={() => this.handleTab("phone")}
                    />
                    <label htmlFor="phone">
                      <span styleName="check"/>
                      Баланс<br/> телефона
                    </label>
                    <input
                      type="checkbox"
                      id="wallet"
                      checked={settings.tabs.includes("wallet")}
                      disabled={this.applyDisabled("wallet")}
                      onChange={() => this.handleTab("wallet")}
                    />
                    <label htmlFor="wallet">
                      <span styleName="check"/>
                      Электронные<br/> деньги
                    </label>
                  </div>
                </div>
              </section>
            </Element>
          </main>
        </div>
        <div styleName="wave" className={cx(settings.layout)}/>
        <div styleName="overlay">
          <div styleName="navigation-container">
            <div styleName="main-footer">
              <nav>
                <ul styleName="footer-links">
                  <div>
                    <li>
                      <a href="http://arsenalpay.com/">English</a>
                    </li>
                    <li>
                      <a href="https://arsenalpay.ru/about.html">О компании</a>
                    </li>
                    <li>
                      <a href="https://arsenalpay.ru/offers.html">
                        Дополнительные услуги
                      </a>
                    </li>
                    <li>
                      <a href="https://arsenalpay.ru/documentation.html">
                        Документация
                      </a>
                    </li>
                    <li>
                      <a href="https://arsenalpay.ru/contacts.html">Контакты</a>
                    </li>
                    <li>
                      <a href="https://arsenalpay.ru/support.html">Поддержка</a>
                    </li>
                  </div>
                  <div styleName="connect">
                    <li>
                      <a href="https://arsenalpay.ru/#registerModal">
                        Подключиться
                      </a>
                    </li>
                  </div>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state
});

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

export default connect(mapStateToProps)(CSSModules(Form, styles));



// WEBPACK FOOTER //
// ./src/App.js